"use strict";

var _interopRequireDefault = require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.SaleSource = exports.SaleChannel = exports.FilterAge = void 0;
require("core-js/modules/es.array.concat.js");
var _classCallCheck2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/classCallCheck.js"));
var _createClass2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/createClass.js"));
var _callSuper2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/callSuper.js"));
var _inherits2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/inherits.js"));
var _defineProperty2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/defineProperty.js"));
var _tslib = require("tslib");
var _staff = require("@/api/staff");
var _vuePropertyDecorator = require("vue-property-decorator");
var _CustomerTable = require("../CustomerTable.vue");
var FilterCustomer = /*#__PURE__*/function (_Vue) {
  function FilterCustomer() {
    var _this;
    (0, _classCallCheck2.default)(this, FilterCustomer);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = (0, _callSuper2.default)(this, FilterCustomer, [].concat(args));
    (0, _defineProperty2.default)(_this, "visible", false);
    (0, _defineProperty2.default)(_this, "form", {});
    (0, _defineProperty2.default)(_this, "staffs", []);
    (0, _defineProperty2.default)(_this, "groupCustomerTrans", _CustomerTable.groupCustomerTrans);
    (0, _defineProperty2.default)(_this, "SaleChannel", SaleChannel);
    (0, _defineProperty2.default)(_this, "SaleSource", SaleSource);
    (0, _defineProperty2.default)(_this, "filterAgeTrans", filterAgeTrans);
    (0, _defineProperty2.default)(_this, "dob", []);
    (0, _defineProperty2.default)(_this, "registerDate", []);
    (0, _defineProperty2.default)(_this, "createDate", []);
    return _this;
  }
  (0, _inherits2.default)(FilterCustomer, _Vue);
  return (0, _createClass2.default)(FilterCustomer, [{
    key: "watchFormDob",
    value: function watchFormDob(date) {
      this.form.dobFrom = date[0];
      this.form.dobTo = date[1];
    }
  }, {
    key: "watchFormRegisterDate",
    value: function watchFormRegisterDate(date) {
      this.form.registerFrom = date[0];
      this.form.registerTo = date[1];
    }
  }, {
    key: "watchFormCreateDate",
    value: function watchFormCreateDate(date) {
      this.form.createFrom = date[0];
      this.form.createTo = date[1];
    }
  }, {
    key: "handleClearAll",
    value: function handleClearAll() {
      this.form = {};
      this.dob = [];
      this.registerDate = [];
      this.createDate = [];
      this.handleApply();
    }
  }, {
    key: "handleApply",
    value: function handleApply() {
      this.visible = false;
      debugger;
      this.$emit("apply", this.form);
    }
  }, {
    key: "fetchStaffs",
    value: function fetchStaffs() {
      var _this2 = this;
      _staff.staffApi.findAll().then(function (res) {
        return _this2.staffs = res.data.data;
      });
    }
  }, {
    key: "created",
    value: function created() {
      this.fetchStaffs();
    }
  }, {
    key: "handleOpen",
    value: function handleOpen(query) {
      this.visible = true;
      if (!!(query !== null && query !== void 0 && query.dobFrom) && !!(query !== null && query !== void 0 && query.dobTo)) {
        this.dob = [query.dobFrom, query.dobTo];
      }
    }
  }]);
}(_vuePropertyDecorator.Vue);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Watch)("dob", {
  deep: true
})], FilterCustomer.prototype, "watchFormDob", null);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Watch)("registerDate", {
  deep: true
})], FilterCustomer.prototype, "watchFormRegisterDate", null);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Watch)("createDate", {
  deep: true
})], FilterCustomer.prototype, "watchFormCreateDate", null);
FilterCustomer = (0, _tslib.__decorate)([_vuePropertyDecorator.Component], FilterCustomer);
var _default = exports.default = FilterCustomer;
var SaleSource;
(function (SaleSource) {
  SaleSource["Facebook"] = "FACEBOOK";
  SaleSource["Zalo"] = "ZALO";
  SaleSource["Web"] = "WEB";
  SaleSource["Hotline"] = "HOTLINE";
  SaleSource["Sendo"] = "SENDO";
  SaleSource["Tiki"] = "TIKI";
  SaleSource["Other"] = "OTHER";
})(SaleSource || (exports.SaleSource = SaleSource = {}));
var SaleChannel;
(function (SaleChannel) {
  SaleChannel["Facebook"] = "FACEBOOK";
  SaleChannel["Zalo"] = "ZALO";
  SaleChannel["Web"] = "WEB";
  SaleChannel["Hotline"] = "HOTLINE";
  SaleChannel["Sendo"] = "SENDO";
  SaleChannel["Tiki"] = "TIKI";
  SaleChannel["Other"] = "OTHER";
})(SaleChannel || (exports.SaleChannel = SaleChannel = {}));
var FilterAge;
(function (FilterAge) {
  FilterAge["Under15"] = "UNDER15";
  FilterAge["From15To22"] = "FROM15TO22";
  FilterAge["From23To29"] = "FROM23TO29";
  FilterAge["From30To39"] = "FROM30TO39";
  FilterAge["Over40"] = "OVER40";
})(FilterAge || (exports.FilterAge = FilterAge = {}));
var filterAgeTrans = (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)({}, FilterAge.Under15, "Under 15 years old"), FilterAge.From15To22, "From 15 to 22 years old"), FilterAge.From23To29, "From 23 to 29 years old"), FilterAge.From30To39, "From 30 to 39 years old"), FilterAge.Over40, "Over 40 years old");